var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHolidayPackage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 31,
    viewBox: "0 0 27 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 13.1522C27 14.9131 25.1884 12.2717 23.0145 12.5652C21.9354 12.2487 20.1159 13.1522 19.3913 13.7391C17.942 12.8587 16.4396 12.2717 14.3188 12.2717C12.1981 12.2717 10.6957 13.1522 9.6087 13.7391C8.15942 12.8587 6.4862 12.3171 5.26087 12.5652C2.36232 13.1522 2 14.9552 2 12.8587C2 8.48245 7.67755 5.22827 14.6812 5.22827C21.6848 5.22827 27 8.77593 27 13.1522Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8188 2.00003C15.8188 1.1716 15.1473 0.500032 14.3188 0.500032C13.4904 0.500032 12.8188 1.1716 12.8188 2.00003H15.8188ZM15.8188 4.93481V2.00003H12.8188V4.93481H15.8188Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8188 28.413C12.8188 29.2414 13.4904 29.913 14.3188 29.913C15.1473 29.913 15.8188 29.2414 15.8188 28.413H12.8188ZM12.8188 26.6521V28.413H15.8188V26.6521H12.8188Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3188 24.3044V12.5653",
    stroke: "black",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.68906 25.4783V26.9783H4.78141L4.36029 26.1742L5.68906 25.4783ZM0.671223 19.1308C0.286858 18.3969 0.570181 17.4904 1.30404 17.106C2.03791 16.7217 2.94441 17.005 3.32878 17.7389L0.671223 19.1308ZM22.2899 26.9783H5.68906V23.9783H22.2899V26.9783ZM4.36029 26.1742L0.671223 19.1308L3.32878 17.7389L7.01784 24.7823L4.36029 26.1742Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3923 28.2121C21.8275 28.917 21.6088 29.8413 20.9038 30.2764C20.1989 30.7116 19.2747 30.4929 18.8395 29.7879L21.3923 28.2121ZM19.2184 24.6904L21.3923 28.2121L18.8395 29.7879L16.6656 26.2662L19.2184 24.6904Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.51142 28.4292C3.19615 29.1953 3.56162 30.0719 4.32771 30.3871C5.09381 30.7024 5.97042 30.3369 6.28569 29.5708L3.51142 28.4292ZM4.96069 24.9074L3.51142 28.4292L6.28569 29.5708L7.73496 26.0491L4.96069 24.9074Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4203 24.8913L10.1028 22.5435H4.17391",
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHolidayPackage);
export default __webpack_public_path__ + "static/media/holiday-package.690fde76414ae0e00ed405968bd46b53.svg";
export { ForwardRef as ReactComponent };